



























































import { Component } from "vue-property-decorator";

import { DialogSection, DialogForm, FormText } from "sitewhere-ide-components";
import { VFlex } from "vuetify/lib";

import {
  IMqttEventSourceConfiguration,
  IMqttSecurityFields
} from "sitewhere-configuration-model";

@Component({ components: { VFlex, DialogForm, FormText }, validations: {} })
export default class MqttAuthenticationFields extends DialogSection {
  username: string | null = null;
  password: string | null = null;
  clientId: string | null = null;
  cleanSession: boolean | null = null;
  trustStorePath: string | null = null;
  trustStorePassword: string | null = null;
  keyStorePath: string | null = null;
  keyStorePassword: string | null = null;

  /** Reset section content */
  reset(): void {
    this.username = null;
    this.password = null;
    this.clientId = null;
    this.cleanSession = null;
    this.trustStorePath = null;
    this.trustStorePassword = null;
    this.keyStorePath = null;
    this.keyStorePassword = null;
    this.$v.$reset();
  }

  /** Perform validation */
  validate(): boolean {
    this.$v.$touch();
    return !this.$v.$invalid;
  }

  /** Load form data from an object */
  load(input: IMqttEventSourceConfiguration): void {
    this.username = input.username;
    this.password = input.password;
    this.trustStorePath = input.trustStorePath;
    this.trustStorePassword = input.trustStorePassword;
    this.keyStorePath = input.keyStorePath;
    this.keyStorePassword = input.keyStorePassword;
  }

  /** Save form data to an object */
  save(): IMqttSecurityFields {
    return {
      username: this.username || "",
      password: this.password || "",
      trustStorePath: this.trustStorePath || "",
      trustStorePassword: this.trustStorePassword || "",
      keyStorePath: this.keyStorePath || "",
      keyStorePassword: this.keyStorePassword || ""
    };
  }
}
